import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("img", {
      class: _normalizeClass(["icon-only", { hidden: !_ctx.iconOnly }]),
      alt: "inpart",
      src: "img/logo/menu-inpart-icon.svg"
    }, null, 2),
    _createElementVNode("img", {
      class: _normalizeClass(["full-logo", { hidden: _ctx.iconOnly }]),
      alt: "inpart",
      src: "img/logo/menu-inpart-logo.svg"
    }, null, 2)
  ]))
}